import React from 'react'
import { Box, Typography } from '@mui/material'
import { realTimeTasks, userComesFromUrl } from './@signals'

import { AppLinearProgress } from '@components'
import { isEmpty } from '@ui-seeker/utils'


export default function RealTimeLinearProgress() {
	if(isEmpty(realTimeTasks.value)) return null
	
	return <Box sx={{ display: 'flex' }}>
		<AppLinearProgress actual={realTimeTasks.value?.numTasks} total={realTimeTasks.value?.completeTasks} variant={realTimeTasks.value?.numTasks <= 0 ? '' : 'determinate'} />
		<Typography variant='body2' sx={{ ml: '1.5rem', fontSize: '0.875rem', color: 'grey' }}>[{realTimeTasks.value?.numTasks}/{realTimeTasks.value?.completeTasks}]</Typography>
	</Box>
}